import _objectDefineProperty from "../internals/object-define-property";
import _hasOwnProperty from "../internals/has-own-property";
import _wellKnownSymbol from "../internals/well-known-symbol";
var exports = {};
var defineProperty = _objectDefineProperty.f;
var hasOwn = _hasOwnProperty;
var wellKnownSymbol = _wellKnownSymbol;
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, {
      configurable: true,
      value: TAG
    });
  }
};
export default exports;